module.exports = __webpack_public_path__ + "5ae93e26b47e540f67e1ffbd3b2daa89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/15.jpg
// module id = 1341
// module chunks = 47